import { createSlice } from "@reduxjs/toolkit";
import {
  getQuotes,
  addNewQuote,
  updateQuote,
  deleteQuote,
  getWebQuotation,
  addNewWebQuotation,
  updateWebQuotation,
  deleteWebQuotation,
} from "./thunk";

export const initialState = {
  quotes: [],
  error: {},
  isLoading: false,
  isQuotesSuccess: false,
  isQuotesFailed: false,

  webQuotation: [],
  webQuotationError: {},
  isWebQuotationLoading: false,
  isWebQuotationQuotesSuccess: false,
  isWebQuotationQuotesFailed: false,
};

const quotesSlice = createSlice({
  name: "quote",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //==================================[ /getQuotes/ ]=======================================
    builder.addCase(getQuotes.pending, (state) => {
      state.isLoading = true;
      state.isQuotesSuccess = false;
      state.error = null;
    });
    builder.addCase(getQuotes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isQuotesSuccess = true;
      state.quotes = action.payload;
    });
    builder.addCase(getQuotes.rejected, (state, action) => {
      state.isLoading = false;
      state.isQuotesSuccess = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewQuote.fulfilled, (state, action) => {
      state.quotes.push(action.payload);
      state.isQuoteAdd = true;
      state.isQuoteAddFail = false;
    });

    builder.addCase(addNewQuote.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isQuoteAdd = false;
      state.isQuoteAddFail = true;
    });

    builder.addCase(updateQuote.fulfilled, (state, action) => {
      state.quotes = state.quotes.map((quote) =>
        quote._id.toString() === action.payload._id.toString()
          ? { ...quote, ...action.payload }
          : quote
      );
      state.isQuoteUpdate = true;
      state.isQuoteUpdateFail = false;
    });

    builder.addCase(updateQuote.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isQuoteUpdate = false;
      state.isQuoteUpdateFail = true;
    });

    builder.addCase(deleteQuote.fulfilled, (state, action) => {
      state.quotes = (state.quotes || []).filter(
        (quote) => quote._id.toString() !== action.payload.id.toString()
      );

      state.isQuoteDelete = true;
      state.isQuoteDeleteFail = false;
    });

    builder.addCase(deleteQuote.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isQuoteDelete = false;
      state.isQuoteDeleteFail = true;
    });

    //==================================[ /getWebQuotation/ ]=======================================
    builder.addCase(getWebQuotation.pending, (state) => {
      state.isWebQuotationLoading = true;
      state.isWebQuotationSuccess = false;
      state.webQuotationError = null;
    });
    builder.addCase(getWebQuotation.fulfilled, (state, action) => {
      state.isWebQuotationLoading = false;
      state.isQuotesSuccess = true;
      state.webQuotation = action.payload;
    });
    builder.addCase(getWebQuotation.rejected, (state, action) => {
      state.isWebQuotationLoading = false;
      state.isWebQuotationSuccess = false;
      state.webQuotationError = action.error.message;
    });

    builder.addCase(addNewWebQuotation.fulfilled, (state, action) => {
      state.webQuotation.push(action.payload);
      state.isWebQuotationAdd = true;
      state.isWebQuotationAddFail = false;
    });

    builder.addCase(addNewWebQuotation.rejected, (state, action) => {
      state.webQuotationError = action.payload?.error ?? action.error?.message ?? null;
      state.isWebQuotationAdd = false;
      state.isWebQuotationAddFail = true;
    });

    builder.addCase(updateWebQuotation.fulfilled, (state, action) => {
      state.webQuotation = state.webQuotation.map((wquote) =>
        wquote._id.toString() === action.payload._id.toString()
          ? { ...wquote, ...action.payload }
          : wquote
      );
      state.isWebQuotationUpdate = true;
      state.isWebQuotationUpdateFail = false;
    });

    builder.addCase(updateWebQuotation.rejected, (state, action) => {
      state.webQuotationError = action.payload?.error ?? action.error?.message ?? null;
      state.isWebQuotationUpdate = false;
      state.isWebQuotationUpdateFail = true;
    });

    builder.addCase(deleteWebQuotation.fulfilled, (state, action) => {
      state.webQuotation = (state.webQuotation || []).filter(
        (wquote) => wquote._id.toString() !== action.payload.id.toString()
      );

      state.isWebQuotationDelete = true;
      state.isWebQuotationDeleteFail = false;
    });

    builder.addCase(deleteWebQuotation.rejected, (state, action) => {
      state.error = action.payload?.error ?? action.error?.message ?? null;
      state.isWebQuotationDelete = false;
      state.isWebQuotationDeleteFail = true;
    });
  },
});

export default quotesSlice.reducer;
